import React from 'react'
import { Menu, MenuItem } from '@szhsin/react-menu'
import Icon from '@mdi/react'
import { mdiDotsVertical } from '@mdi/js'

export interface MenuItemInfo {
  text: string
  onClick: (id?: number) => void
  clickParameter?: number
}

interface PopupMenuProps {
  menuItemList: MenuItemInfo[]
}

const PopupMenu = ({ menuItemList }: PopupMenuProps): JSX.Element => (
  <Menu
    menuButton={
      <span role='button'>
        <Icon path={mdiDotsVertical} size={1} />
      </span>
    }
  >
    {menuItemList.map((menuItem: MenuItemInfo, index: number) => (
      <MenuItem
        onClick={() => menuItem.onClick(menuItem.clickParameter)}
        key={index}
      >
        {menuItem.text}
      </MenuItem>
    ))}
  </Menu>
)

export default PopupMenu
